import TextInput from '../../text-input';
import { SearchIcon } from '@primer/octicons-react';
import { ActionList, Box, Checkbox, FormControl } from '@primer/react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { ICondition } from '../type/IDataGridProps';
import Button from '../../ui/button';
import ModalActions from '../../ui/modal/ModalActions';
interface IHeaderFilterModalProps {
    condition?: ICondition,
    distinctedValues: any[],
    onApply: (values: any[]) => void,
    onCancel: () => void
}
const HeaderFilterModal = ({ distinctedValues, onApply, onCancel, condition }: IHeaderFilterModalProps) => {
    const [selectedTemp, setSelectedTemp] = useState<any[]>([]);
    const [searchKey, setSearchKey] = useState<string>("");
    const filterdData = useMemo(() => {
        if (searchKey === "") return distinctedValues;
        return distinctedValues.filter(x => (x?.toString() ?? "").toLowerCase().includes(searchKey.toLowerCase()))
    }, [searchKey, distinctedValues])
    const onSubmit = useCallback(() => {
        onApply(selectedTemp)
    }, [onApply, selectedTemp])
    useEffect(() => {
        if (condition && Array.isArray(condition.value)) {
            setSelectedTemp(condition.value)
        }
    }, [condition])
    const isSelectedAll = useMemo(() => {
        return !distinctedValues.find(x => !selectedTemp.includes(x))
    }, [distinctedValues, selectedTemp])
    

    return (
        <Box sx={{ p: 3, width: "350px", display: "grid", gap: 2 }}>
            <Box>
                <TextInput placeholder='Tìm kiếm'
                    block
                    leadingVisual={SearchIcon}
                    onValueDelayChanged={(value) => {
                        setSearchKey(value)
                    }}
                />
            </Box>
            <Box sx={{ pl: 2 }}>
                <FormControl>
                    <Checkbox checked={isSelectedAll} onChange={() => {
                        if (isSelectedAll) {
                            setSelectedTemp([])
                        } else {
                            setSelectedTemp([...distinctedValues])
                        }
                    }} />
                    <FormControl.Label>Chọn tất cả</FormControl.Label>
                </FormControl>
            </Box>
            <Box sx={{
                maxHeight: "300px",
                overflow: "auto"
            }}>
                <ActionList selectionVariant='multiple'
                    variant='full'
                >
                    {filterdData.map((value, idx) => {
                        const isSelected = selectedTemp.find(s => s === value)!== undefined;
                        return (
                            <ActionList.Item key={idx}
                                selected={isSelected}
                                onSelect={() => {
                                    if (isSelected) {
                                        setSelectedTemp(selectedTemp.filter(x => x !== value))
                                    } else {
                                        setSelectedTemp([...selectedTemp, value])
                                    }
                                }}
                            >
                                {value}
                            </ActionList.Item>
                        );
                    })}
                </ActionList>
            </Box>
            <ModalActions>
                <Button text='Đóng' onClick={onCancel} />
                <Button text='Áp dụng' variant='primary'
                    onClick={onSubmit}
                />
            </ModalActions>
        </Box>
    );
};

export default HeaderFilterModal;